import { render } from "./TownList.vue?vue&type=template&id=e5357e36&scoped=true"
import script from "./TownList.vue?vue&type=script&lang=js"
export * from "./TownList.vue?vue&type=script&lang=js"

import "./TownList.vue?vue&type=style&index=0&id=e5357e36&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5357e36"]])

export default __exports__